import React from 'react';
import FormularioDirecto from '../../components/FormularioDirecto';

const FormularioDirectoPage = () => <FormularioDirecto />;

export default FormularioDirectoPage;
